module.exports = __webpack_public_path__ + "static/img/type2.a8fd8df4.jpg";